import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import NewsSection from './components/NewsSection';
import ServicesOverview from './components/ServicesOverview';
import PlansOverview from './components/PlansOverview';
import CtaSection from './components/CtaSection';

export default function HomePage() {
  return (
    <div className="min-h-screen" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
      <Navbar />
      <main>
        <HeroSection />
        <NewsSection />
        <ServicesOverview />
        <PlansOverview />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}
